// extracted by mini-css-extract-plugin
export const sectionTextBanner = "textBanner-module--sectionTextBanner--1LGke";
export const sectionContent = "textBanner-module--sectionContent--1Vb2f";
export const richtext = "textBanner-module--richtext--2Dnny";